// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gBSw","toggle":"styles_toggle__3ftkc","preview":"styles_preview__2Ctt-"};